export default __webpack_public_path__ + "static/media/sg90@3x.61f50b54.png";